import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';


export default function SubscriptionModal() {
    let [isOpen, setIsOpen] = useState(true);
  
    function closeModal() {
      setIsOpen(false);
    }
  
    function openModal() {
      setIsOpen(true);
    }
  
    //DetailView details
  
    return (
        
            <Transition appear show={isOpen} as={Fragment}>
            <Dialog
          as="div"
          className="fixed inset-0 z-20 overflow-y-auto lg:pl-8 lg:pr-8 bg-black bg-opacity-75"
          onClose={closeModal}
        >
            <div className="min-h-screen w-full px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full lg:w-2/3  mx-auto lg:flex  my-8 overflow-hidden text-left align-middle transition-all transform bg-white  shadow-xl rounded">
                <div className="w-full hidden border  lg:w-1/2 lg:inline">
                    <img src="/imgs/bn9.jpg" className="h-full object-center object-contain"></img>
                </div>
                <div className="p-4 text-center w-full">
                    <h2 className="text-2xl mt-12 font-bold uppercase text-gray-700">wait, we want to give you a </h2>
                    <h3 className="text-sm mt-4  text-gray-700">50% OFF Coupon Code for your first purchase !</h3>

                <div className='mt-8 pb-8 lg:pl-12 mb-24 lg:pr-12'>
                    <input className="bg-gray-400 border lg:w-2/3 p-2 rounded " placeholder="Enter Email Address Here" />
                    <button className="bg-[#fb9815]  border lg:w-2/3 p-2 text-white rounded mt-4 mb-2" >SEND ME A 50% COUPON NOW</button><br />
                    <button type="button" onClick={closeModal} className="w-2/3 p-2 text-gray-800 undertline rounded mt-4" >NO, THANKS</button>
                </div>
                <div className="w-full">
                    <div className="float-right"><input type="checkbox" className="mr-2"/><label className="text-gray-600 text-sm ">Don't show this popup again</label></div>
                </div>
                </div>
              </div>
            </Transition.Child>
            </div>
        </Dialog>
            </Transition>
        
    );
    }